/**
 * TODO: refactor
 */
export class JapaneseCharacter {
  public static readonly headCharacters: string[] = ["あ", "か", "さ", "た", "な", "は", "ま", "や", "ら", "わ"];

  public static getColumnCharacters(head: string): string[] {
    if (!head) { return []; }
    switch (head) {
      case "あ": return ["あ", "い", "う", "え", "お"];
      case "か": return ["か", "き", "く", "け", "こ"];
      case "さ": return ["さ", "し", "す", "せ", "そ"];
      case "た": return ["た", "ち", "つ", "て", "と"];
      case "な": return ["な", "に", "ぬ", "ね", "の"];
      case "は": return ["は", "ひ", "ふ", "へ", "ほ"];
      case "ま": return ["ま", "み", "む", "め", "も"];
      case "や": return ["や", "ゆ", "よ"];
      case "ら": return ["ら", "り", "る", "れ", "ろ"];
      case "わ": return ["わ", "を", "ん"];
    }
    return [];
  }

  public static getHeadCharacter(text: string): string {
    if (!text) { return null; }
    for (const head of this.headCharacters) {
      if (this.getColumnCharacters(head).find(c => c === text)) { return head; }
    }
    return null;
  }
}
